import { IconButton as ChordsIconButton } from '~/chords/IconButton';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const IconButton = withClassNameHoc(ChordsIconButton);

IconButton.displayName = 'IconButton';
